import { serialize } from 'utils/utils';
import { CALL_API, Schemas } from '../middleware/api';

export const TYPES = {
  DIMENSIONS_RESULTS_REQUEST: 'DIMENSIONS_RESULTS_REQUEST',
  DIMENSIONS_RESULTS_SUCCESS: 'DIMENSIONS_RESULTS_SUCCESS',
  DIMENSIONS_RESULTS_FAILURE: 'DIMENSIONS_RESULTS_FAILURE',
};

export const loadDimensions = (params) => {
  const defaultParams = {
    dimensions: 'NEED_TO_OVERWRITE_THIS',
    state: 'NEED_TO_OVERWRITE_THIS',
  };
  return {
    [CALL_API]: {
      types: [
        TYPES.DIMENSIONS_RESULTS_REQUEST,
        TYPES.DIMENSIONS_RESULTS_SUCCESS,
        TYPES.DIMENSIONS_RESULTS_FAILURE,
      ],
      schema: Schemas.DIMENSIONS,
      endpoint: `/bridge/dimensions?${serialize(Object.assign(defaultParams, params))}`,
    },
  };
};



/** WEBPACK FOOTER **
 ** ./src/redux/actions/dimensionsActions.js
 **/